{
  "venueEdit": {
    "insertFailure": "Veranstaltungsort konnte nicht erstellt werden",
    "editFailure": "Veranstaltungsort konnte nicht bearbeitet werden",
    "deleteFailure": "Veranstaltungsort konnte nicht gelöscht werden",
    "creationSuccess": "Der Veranstaltungsort wurde erfolgreich erstellt",
    "editSuccess": "Der Veranstaltungsort wurde erfolgreich geändert",
    "deleteSuccess": "Der Veranstaltungsort wurde erfolgreich gelöscht",
    "topLevel": "Oberste Ebene"
  },
  "resetZoom": "Zoom zurücksetzen",
  "shareOrExport": {
    "title": "Zeitplan teilen/exportieren",
    "shareLinkOptionTitle": "Link teilen",
    "shareLinkOptionDescription": "Den ausgewählten Zeitplan über einen schreibgeschützten Link teilen (Ablauf 7 Tage)",
    "exportOptionTitle": "Zeitplan exportieren",
    "exportOptionDescription": "Exportiert den ausgewählten Zeitplan",
    "shareLinkLabel": "Link",
    "exportStarted": "Der Export wurde gestartet",
    "pickOption": "Wählen Sie eine Option"
  },
  "eventBlocksImport": "Der Import wurde erfolgreich abgeschlossen",
  "shareSchedule": "Der Link zum gemeinsamen Zeitplan wurde in Ihre Zwischenablage kopiert",
  "visitSchedule": "Zeitplan für den Besuch"
}